import { FetchAssertsService } from '@/packages/query-state/shared/services/FetchAssertsService';
import { type IQueryStateAppContext } from '@/packages/query-state/shared/types/appContext';

import {
  type IAddFavoriteResponse200,
  type IAddFavoriteResponse400,
  type TAddFavoriteRequest,
  type TAddFavoriteResponse_1,
  createAddFavoriteModel,
  fetchAddFavorite,
} from '@/repositories/generated/shared/favorites/v1/add-favorite';

export function fetchAddFavoriteService(
  applicationContext: IQueryStateAppContext,
  parameters: TAddFavoriteRequest,
): Promise<TAddFavoriteResponse_1> {
  const { httpApi, logger } = applicationContext;

  const fetchAssertsService = new FetchAssertsService(
    createAddFavoriteModel(parameters),
    '@/shared/store/serverSide/favorites/v1/add-favorite/internal/fetchService.ts',
    logger,
  );

  return fetchAddFavorite<IAddFavoriteResponse200, IAddFavoriteResponse400>({
    httpApi,
    parameters,
  }).then(
    result => {
      const statusCode = result.statusCode;

      switch (result.statusCode) {
        case 200:
          return result.response;
        case 400:
          throw fetchAssertsService.assert400StatusCodeError(result);
        default:
          throw fetchAssertsService.assertUnknownStatusCodeError(statusCode);
      }
    },
    error => {
      throw fetchAssertsService.assertUnknownServerError(error);
    },
  );
}
